module.exports = __webpack_public_path__ + "static/media/Arthur.61cb780c.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/actors/Arthur.png
// module id = 347
// module chunks = 0